import {
  TaskDomainSchema,
  TaskPrioritySchema,
  TaskStatusSchema,
  TaskSubtypeSchema,
} from "@redotech/redo-model/task/task";
import {
  TaskAssigneeTypeSchema,
  TaskAssignmentStatusSchema,
} from "@redotech/redo-model/task/task-assignment";
import * as z from "zod/v4";
import { defineStreamChannelSchema } from "./definitions";

export const liveTaskAssignmentSchema = z.object({
  id: z.string(),
  assigneeType: TaskAssigneeTypeSchema,
  assignedLegacyUserId: z.nullable(z.string()),
  assignedRole: z.nullable(z.string()),
  status: TaskAssignmentStatusSchema,
  assignedAt: z.string(),
  resolvedAt: z.nullable(z.string()),
});

export const liveTaskUserStateSchema = z.object({
  seenAt: z.nullable(z.string()),
  dismissedAt: z.nullable(z.string()),
  claimedAt: z.nullable(z.string()),
  lastNotifiedAt: z.nullable(z.string()),
  lastBrowserNotifiedAt: z.nullable(z.string()),
});

export const liveTaskReferenceSchema = z.object({
  referenceTable: z.string(),
  referenceId: z.string(),
});

export const liveTaskSchema = z.object({
  id: z.string(),
  accountId: z.string(),
  locationId: z.nullable(z.string()),
  name: z.nullable(z.string()),
  domain: TaskDomainSchema,
  subtype: TaskSubtypeSchema,
  status: TaskStatusSchema,
  priority: TaskPrioritySchema,
  referenceType: z.string(),
  referenceId: z.string(),
  references: z.array(liveTaskReferenceSchema),
  createdByLegacyUserId: z.nullable(z.string()),
  claimedByLegacyUserId: z.nullable(z.string()),
  completedByLegacyUserId: z.nullable(z.string()),
  dueAt: z.nullable(z.string()),
  claimedAt: z.nullable(z.string()),
  completedAt: z.nullable(z.string()),
  cancelledAt: z.nullable(z.string()),
  createdAt: z.string(),
  updatedAt: z.string(),
  assignments: z.array(liveTaskAssignmentSchema),
  userState: z.nullable(liveTaskUserStateSchema),
});
export type LiveTask = z.infer<typeof liveTaskSchema>;

export const taskUpsertedEventSchema = z.object({
  _tag: z.literal("taskUpserted"),
  task: liveTaskSchema,
});
export type TaskUpsertedEvent = z.infer<typeof taskUpsertedEventSchema>;

export const taskRemovedEventSchema = z.object({
  _tag: z.literal("taskRemoved"),
  taskId: z.string(),
});
export type TaskRemovedEvent = z.infer<typeof taskRemovedEventSchema>;

export const tasksStreamEventSchema = z.discriminatedUnion("_tag", [
  taskUpsertedEventSchema,
  taskRemovedEventSchema,
]);
export type TasksStreamEvent = z.infer<typeof tasksStreamEventSchema>;

export const tasksStreamInputSchema = z.object({});
export type TasksStreamInput = z.infer<typeof tasksStreamInputSchema>;

export const tasksStreamInitialSchema = z.object({
  _tag: z.literal("tasksInitial"),
  tasks: z.array(liveTaskSchema),
});
export type TasksStreamInitial = z.infer<typeof tasksStreamInitialSchema>;

export const tasksStreamChannelSchema = defineStreamChannelSchema({
  eventSchema: tasksStreamEventSchema,
  initialSchema: tasksStreamInitialSchema,
  inputSchema: tasksStreamInputSchema,
});
